<template>
  <!-- will change url query: section=number -->
  <!-- <PageMenu :sections="sections">
    something in menu-content
  </PageMenu> -->
  <div class="menu">
    <div class="menu-head">
      <div class="menu-head__title">
        <slot name="menuHeadTitle">{{ menuHeadTitle }}</slot>
      </div>
      <div class="menu-head__items">
        <div
          v-for="(section, i) in sections"
          :key="section.name"
          class="menu-head__item"
          :class="{ active: Number($route.query.section) == i }"
          @click="$router.replace({ query: { section: String(i) } })"
        >
          {{ section.name }}
        </div>
      </div>
    </div>
    <div class="menu-content">
      <!-- <component :is="sectionView"></component> -->
      <slot>選單內容</slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sections: {
      type: Array,
      required: true,
      default: function validateSections() {
        return [];
      },
    },
    menuHeadTitle: {
      type: String,
      default: 'Switch Section',
    },
  },
  mounted() {
    const sectionQuery = this.$route.query.section;
    if (sectionQuery === undefined || sectionQuery === null) {
      this.$router.replace({ query: { section: '0' } });
    }
  },
};
</script>

<style></style>
